/**
 * Analytics Module - Centralized tracking logic for Resumen Digital
 */

/**
 * Sends an event to Google Analytics 4.
 * Handles both the gtag() function and the dataLayer fallback for gtag.js.
 * 
 * @param {string} name - The name of the event (snake_case).
 * @param {Object} params - The parameters for the event.
 */
export function trackEvent(name, params = {}) {
  const eventParams = {
    ...params,
    'timestamp': new Date().toISOString()
  };

  window.dataLayer = window.dataLayer || [];
  
  // GTM expects objects with an 'event' property
  window.dataLayer.push({
    'event': name,
    ...eventParams
  });
}
